import { CurationDetails } from './CurationDetails';

export default CurationDetails;
